const firebaseConfig = {
    apiKey: "AIzaSyB5LXTLY0LgAkZHUgP1HfrI7amJkejhmCc",
    authDomain: "my-market-manager.firebaseapp.com",
    databaseURL: "https://my-market-manager.firebaseio.com",
    projectId: "my-market-manager",
    storageBucket: "my-market-manager.appspot.com",
    messagingSenderId: "380088857106",
    appId: "1:380088857106:web:46a55a139f9e3fbbecdecb",
    measurementId: "G-5VV57EYV2S"
  };

export const apiToken = 'pk_93e194ee2d534b2aa5ca92f44f3e50e5';

export const alphaApiToken = '04ZSUBF5KMPM0GPA';
 
export default firebaseConfig;